import React, { useState } from 'react';
import RegistroEvento from '../../components/RegistroEvento';
import ListadoEventos from '../../components/ListadoEventos';

const EventosPage = () => {
    const [reload, setReload] = useState(false);

    const handleEventoCreado = () => {
        setReload(!reload);
    };

    return (
        <div className="flex flex-col lg:flex-row gap-6">
            <div className="w-full lg:w-1/3">
                <RegistroEvento onEventoCreado={handleEventoCreado} />
            </div>
            <div className="w-full lg:w-2/3">
                <ListadoEventos key={reload} />
            </div>
        </div>
    );
};

export default EventosPage;
